<template>
  <div>
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <!-- -->
          <v-container grid-list-md text-xs-left>
            <v-card color="transparent" flat light>
              <v-card-text class="px-0" v-if="!editExternal">
                <v-layout :key="item._id" row v-for="item in infoStadium" wrap>
                  <v-flex xs6>{{item.field}}</v-flex>
                  <v-flex xs6>{{item.data}}</v-flex>
                </v-layout>
                <v-layout>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-spacer></v-spacer>
                    <v-flex d-flex sm4>
                      <v-btn
                        @click="removeForm()"
                        color="error"
                        v-if="action === 'remove'"
                      >{{$t('delete')}}</v-btn>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-text class="px-0" v-else>
                <v-layout wrap>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <v-switch v-model="stadiumLocal.active" :label="$t('active')" color="primary"></v-switch>
                    </v-flex>
                    <v-flex d-flex lg6 md6 sm12 xs12>
                      <v-text-field
                        :rules="valid ? [] : [rules.vacio]"
                        :label="$t('name')"
                        v-model="stadiumLocal.name"
                      ></v-text-field>
                    </v-flex>
                  </v-flex>
                  <v-flex d-flex lg6 md6 sm12 xs12>
                    <v-flex d-flex lg12 md12 sm12 xs12>
                      <geo-map @location="updateLocation" ref="geoMap" :location="locationForMap" />
                    </v-flex>
                  </v-flex>
                  <v-flex d-flex lg6 md6 sm12 xs12>
                    <div class="forms-element">
                      <v-text-field
                        :label="$t('address')"
                        v-model="stadiumLocal.address"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-text-field>
                      <v-text-field
                        :label="$t('cp')"
                        v-model="stadiumLocal.cp"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-text-field>

                      <v-autocomplete
                        :items="listCountries"
                        :rules="valid ? [] : [rules.vacio]"
                        :label="$t('select', {field :$tc('country') })"
                        persistent-hint
                        clearable
                        prepend-icon="location_city"
                        v-model="stadiumLocal.countryId"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-autocomplete>
                      <v-autocomplete
                        :disabled="stadiumLocal.countryId === ''"
                        :items="listProvinces"
                        :rules="valid ? [] : [rules.vacio]"
                        :label="$t('select', {field :$tc('province') })"
                        persistent-hint
                        clearable
                        prepend-icon="edit_location"
                        v-model="stadiumLocal.provinceId"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-autocomplete>
                      <v-autocomplete
                        :disabled="stadiumLocal.provinceId === ''"
                        :items="listCities"
                        :rules="valid ? [] : [rules.vacio]"
                        :label="$t('select', {field :$tc('town') })"
                        persistent-hint
                        clearable
                        prepend-icon="edit_location"
                        v-model="stadiumLocal.townId"
                        autocomplete="new-text"
                        browser-autocomplete
                      ></v-autocomplete>
                    </div>
                  </v-flex>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click="clearForm()" color="warning" small>{{$t('reset')}}</v-btn>
                      <v-btn
                        @click="validarForm()"
                        color="success"
                        small
                        :loading="loading"
                        v-if="action === 'create' && can('create', 'stadium')"
                      >{{$t('save')}}</v-btn>
                      <v-btn
                        @click="updateForm()"
                        color="secondary"
                        small
                        :loading="loading"
                        v-if="action === 'update' && can('edit', 'stadium', stadium)"
                      >{{$t('update')}}</v-btn>
                      <v-btn
                        @click="removeForm()"
                        color="error"
                        small
                        :loading="loading"
                        v-if="action === 'remove' && can('delete', 'stadium', stadium)"
                      >{{$t('delete')}}</v-btn>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import queueToast from '../../../helpers/queueToast'
import rules from '../../../helpers/rules'
import GeoMap from '../../widgets/maps/GeoMaps'

export default {
  name: 'tabInformacion',
  mixins: [rules],
  components: {
    GeoMap
  },
  props: {
    editExternal: {
      type: Boolean,
      required: false,
      default: true
    },
    action: {
      type: String,
      required: false,
      default: 'view'
    },
    status: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      stadiumLocal: {},
      address: '',
      valid: true,
      loading: false
    }
  },
  mounted() {
    this.updateActions()
  },
  watch: {
    action: function(val) {
      this.updateActions()
    },
    stadium: function(val) {
      this.stadiumLocal = val
      this.updateActions()
    }
  },
  computed: {
    ...mapState({
      stadium: state => state.stadiums.stadiumSelected,
      listPitches: state => state.pitches.listPitches,
      listUser: state => state.users.listaUsers,
      listLanguages: state => state.languages.listSelectLanguage,
      listForFindCountries: state => state.countries.list,
      listForFindProvinces: state => state.provinces.list,
      listForFindCities: state => state.cities.list
    }),
    ...mapGetters({
      listCountries: 'countries/selectList',
      listAllProvinces: 'provinces/selectList',
      listAllCities: 'cities/selectList'
    }),
    listProvinces() {
      if (!this.stadiumLocal.countryId) return []
      let me = this
      return this.listAllProvinces.filter(
        item => item.meta === me.stadiumLocal.countryId
      )
    },
    listCities() {
      if (!this.stadiumLocal.provinceId) return []
      let me = this
      return this.listAllCities.filter(
        item => item.meta === me.stadiumLocal.provinceId
      )
    },
    infoStadium() {
      if (!this.stadium) {
        return []
      }
      const baseData = this.stadium
      return [
        {
          field: this.$t('active'),
          data: baseData.active ? this.$t('yes') : this.$t('no')
        },
        {
          field: this.$t('address'),
          data: baseData.address
        },
        {
          field: this.$t('cp'),
          data: baseData.cp
        },
        {
          field: this.$tc('country'),
          data: this.findLocation(baseData.countryId, 'country')
        },
        {
          field: this.$tc('province'),
          data: this.findLocation(baseData.provinceId, 'province')
        },
        {
          field: this.$tc('town'),
          data: this.findLocation(baseData.townId, 'city')
        },
        {
          field: this.$t('createdBy'),
          data: this.userFormat(baseData.createdBy)
        },
        {
          field: this.$t('createdAt'),
          data: this.dateFormat(baseData.createdAt)
        }
      ]
    },
    title() {
      return this.action === 'create' ? '' : this.stadium.name
    },
    locationForMap() {
      if (!this.stadiumLocal) return ''
      let result = ''
      const origin = this.stadiumLocal
      if (origin.address) {
        result += origin.address + ', '
      }
      if (origin.townId) {
        result += this.findLocation(origin.townId, 'city') + ', '
      }
      if (origin.provinceId) {
        result += this.findLocation(origin.provinceId, 'province') + ', '
      }
      /* if (origin.cp) {
          result += origin.cp + ', '
        } */
      if (origin.countryId) {
        result += this.findLocation(origin.countryId) + ', '
      }

      return result
    }
  },
  methods: {
    ...mapActions({
      setNew: 'stadiums/setCreateNew',
      setUpdate: 'stadiums/setUpdateStadium',
      setRemove: 'stadiums/setDeleteStadium'
    }),
    updateActions() {
      if (this.$refs.geoMap) {
        this.$refs.geoMap.$refs.myMap.mapObject.invalidateSize()
      }
      this.clearForm()
      if (this.action === 'update') {
        this.stadiumLocal = this.stadium
        if (this.$refs.geoMap) {
          if (this.stadiumLocal.lat && this.stadiumLocal.long) {
            this.$refs.geoMap.clickMark({
              latlng: {
                lat: this.stadiumLocal.lat,
                lng: this.stadiumLocal.long
              }
            })
          } else {
            this.$refs.geoMap.autoCenter()
          }
        }
      }
    },
    findLocation(id, type = 'country') {
      switch (type) {
        case 'country':
          const country = this.listForFindCountries.find(
            item => item._id === id
          )
          return country ? country.name : ''
        case 'province':
          const province = this.listForFindProvinces.find(
            item => item._id === id
          )
          return province ? province.name : ''
        case 'city':
          const city = this.listForFindCities.find(item => item._id === id)
          return city ? city.name : ''
        default:
          return {}
      }
    },
    dateFormat(date) {
      const newDate = new Date(date)
      return (
        newDate.getDate() +
        ' / ' +
        (newDate.getMonth() + 1) +
        ' / ' +
        newDate.getFullYear()
      )
    },
    userFormat(userId) {
      let result = this.listUser.find(item => item._id === userId)
      return result ? result.name : ''
    },
    languageFormat(languageId) {
      let result = this.listLanguages.find(item => item.value === languageId)
      return result ? result.text : ''
    },
    clearForm() {
      this.valid = true
      this.stadiumLocal = {
        active: false,
        name: '',
        address: '',
        cp: '',
        countryId: '',
        provinceId: '',
        townId: '',
        lat: '',
        long: ''
      }
      if (this.$refs.geoMap) {
        this.$refs.geoMap.searchResult = []
        this.$refs.geoMap.marks = []
      }
    },
    errorForm() {
      let error = false
      let message = []
      const formData = this.stadiumLocal
      if (!formData.name) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('name') }))
      }
      if (!formData.countryId) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('country') }))
      }
      if (!formData.provinceId) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('province') }))
      }
      if (!formData.townId) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('town') }))
      }
      return {
        error,
        message
      }
    },
    createStadium() {
      const stadium = this.stadiumLocal
      return {
        name: stadium.name,
        active: stadium.active,
        address: stadium.address,
        cp: stadium.cp,
        countryId: stadium.countryId,
        provinceId: stadium.provinceId,
        townId: stadium.townId,
        lat: stadium.lat,
        long: stadium.long
      }
    },
    validarForm() {
      const error = this.errorForm()
      if (error.error) {
        this.valid = false
        queueToast(error.message)
        return
      }
      this.loading = true
      this.setNew(this.createStadium())
        .then(_ => this.$emit('close'))
        .finally(_ => (this.loading = false))
    },
    updateForm() {
      const error = this.errorForm()
      if (error.error) {
        queueToast(error.message)
        return
      }
      let stadium = this.createStadium()
      stadium._id = this.stadium._id
      this.loading = true
      this.setUpdate(stadium)
        .then(_ => this.$emit('close'))
        .finally(_ => (this.loading = false))
    },
    removeForm() {
      this.loading = true
      this.setRemove(this.stadium._id)
        .then(_ => this.$emit('close'))
        .finally(_ => (this.loading = false))
    },
    updateLocation(item) {
      this.stadiumLocal.lat = item.lat
      this.stadiumLocal.long = item.lng
      queueToast('Agregada la direccion correctamente', 'success')
    }
  }
}
</script>
